import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=23475f95&lang=css"
import "./index.vue?vue&type=style&index=1&id=23475f95&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=2&id=23475f95&lang=css"

import exportComponent from "E:\\Workspaces\\成品油\\成品油_基础版\\成品油溯源码（扫码）\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23475f95"]])

export default __exports__